export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const API_KEY = '231f3d62-2586-4764-a4bf-cadfae4b52ed';
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
